// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';


// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
 import "./i18n";
import { AuthContextProvider } from './components/Auth/Auth-context';
import "./index.scss";
//import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <BrowserRouter basename="">
    <AuthContextProvider>
      <App />
    </AuthContextProvider>
  </BrowserRouter>
, document.getElementById('root'));

reportWebVitals();
